<template>
  <div class="incomplete-step">
    <svg
      :width="sizeClasses[size]"
      :height="sizeClasses[size]"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
        stroke="#EAECF0"
        stroke-width="2"
      />
      <circle cx="16" cy="16" r="5" fill="#D0D5DD" />
    </svg>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  size: {
    type: String,
    default: "large",
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
});

const sizeClasses = computed(() => {
  return {
    small: "24",
    medium: "32",
    large: "40",
  };
});
</script>

<style scoped></style>
